unit vehicle.details;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCPageControl,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTabSet, WEBLib.Buttons, WEBLib.ExtCtrls,
  Vcl.Controls, VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGrid, VCL.TMSFNCCustomComponent, VCL.TMSFNCGridDatabaseAdapter,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  Vcl.Imaging.GIFImg, Vcl.Menus, WEBLib.Menus, Bcl.Utils;

type
  TfrmVehicleDetails = class(TForm)
    wsbMain: TScrollBox;
    wpBottom: TPanel;
    btnBack: TSpeedButton;
    pcMain: TTMSFNCPageControl;
    tpLoads: TTMSFNCPageControlContainer;
    tpDiesel: TTMSFNCPageControlContainer;
    gLoads: TTMSFNCGrid;
    MessageDlg: TMessageDlg;
    wbDetails: TXDataWebClient;
    qLoadsInfo: TXDataWebDataSet;
    qLoadsInfoLoadConNo: TIntegerField;
    qLoadsInfoRegNo: TStringField;
    qLoadsInfoEmpCode: TStringField;
    qLoadsInfoEmpName: TStringField;
    qLoadsInfoRoute: TStringField;
    qLoadsInfoLoadingDate: TDateField;
    qLoadsInfoOffLoadingDate: TDateField;
    qLoadsInfoTons: TFloatField;
    qLoadsInfoRate: TFloatField;
    qLoadsInfoLoadStartKilos: TIntegerField;
    qLoadsInfoStartKilos: TIntegerField;
    qLoadsInfoEndKilos: TIntegerField;
    qLoadsInfoClientInvNo: TStringField;
    qLoadsInfoSubsInvNo: TStringField;
    qLoadsInfoDocketNo: TStringField;
    qLoadsInfoInvoiceType: TStringField;
    qLoadsInfoRevenue: TFloatField;
    qLoadsInfoLoadingTime: TStringField;
    qLoadsInfoOffLoadingTime: TStringField;
    qLoadsInfoTravelTime: TStringField;
    qLoadsInfoTotalTravelTime: TStringField;
    dsLoadsInfo: TDataSource;
    qDieselInfo: TXDataWebDataSet;
    qDieselInfoOrderNo: TIntegerField;
    qDieselInfoRegNo: TStringField;
    qDieselInfoOrderDate: TDateField;
    qDieselInfoLitres: TFloatField;
    qDieselInfoPrice: TFloatField;
    qDieselInfoAmount: TFloatField;
    qDieselInfoStartKilos: TIntegerField;
    qDieselInfoEndKilos: TIntegerField;
    qDieselInfoTotalKilos: TIntegerField;
    qDieselInfoFullFill: TBooleanField;
    qDieselInfoFuelConsumption: TFloatField;
    qDieselInfoDepotName: TStringField;
    qDieselInfoEmpCode: TStringField;
    qDieselInfoEmpName: TStringField;
    dsDieselInfo: TDataSource;
    gdaLoads: TTMSFNCGridDatabaseAdapter;
    WebWaitMessage1: TWaitMessage;
    gdaDiesel: TTMSFNCGridDatabaseAdapter;
    gDiesel: TTMSFNCGrid;
    pmLoads: TPopupMenu;
    pmlUpdateKilos: TMenuItem;
    pmlUpdateDriver: TMenuItem;
    procedure btnBackClick(Sender: TObject);
    procedure gLoadsGetCellData(Sender: TObject; ACol, ARow: Integer;
      var CellString: string);
    procedure qLoadsInfoAfterOpen(DataSet: TDataSet);
    procedure qDieselInfoAfterOpen(DataSet: TDataSet);
    procedure gDieselGetCellData(Sender: TObject; ACol, ARow: Integer;
      var CellString: string);
  private
    { Private declarations }
    procedure LoadDieselData;
  public
    { Public declarations }
    sCompany,
    sRegNo : String;
    dtStart,
    dtEnd : TDate;
    wDateType,
    wType : Word;
    procedure LoadLoadsData;

  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDatabaseAdapter);

var
  frmVehicleDetails: TfrmVehicleDetails;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common;

procedure TfrmVehicleDetails.btnBackClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmVehicleDetails.gDieselGetCellData(Sender: TObject; ACol,
  ARow: Integer; var CellString: string);
begin
  if ARow < 1 then
    exit;
  if ARow > 0 then
    begin
      if ACol = 1 then
        begin
          CellString := IntToStr(ARow);
        end;
    end;
end;

procedure TfrmVehicleDetails.gLoadsGetCellData(Sender: TObject; ACol,
  ARow: Integer; var CellString: string);
begin
  if ARow < 1 then
    exit;
  if ARow > 0 then
    begin
      if ACol = 1 then
        begin
          CellString := IntToStr(ARow);
        end;
    end;
end;

procedure TfrmVehicleDetails.LoadDieselData;
  procedure OnError(Error : TXDataClientError);
  begin
    MessageDlg.ShowDialog(Error.ErrorMessage, WEBLib.Dialogs.mtError, [mbOk]);
  end;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      qDieselInfo.Close;
      qDieselInfo.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      qDieselInfo.Open;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  wbDetails.RawInvoke('IstfmsloadsService.GetSubsFleetDieselDetails',
                       [sCompany,sRegNo,TBclUtils.DateTimeToISO(dtStart,true),TBclUtils.DateTimeToISO(dtEnd,true)],
                       @OnResultSummary, @OnError);

end;

procedure TfrmVehicleDetails.LoadLoadsData;
  procedure OnError(Error : TXDataClientError);
  begin
    MessageDlg.ShowDialog(Error.ErrorMessage, WEBLib.Dialogs.mtError, [mbOk]);
  end;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      qLoadsInfo.Close;
      qLoadsInfo.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      qLoadsInfo.Open;
      LoadDieselData;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  wbDetails.RawInvoke('IstfmsloadsService.GetSubsFleetLoadsDetails',
                       [sCompany,sRegNo,TBclUtils.DateTimeToISO(dtStart,true),TBclUtils.DateTimeToISO(dtEnd,true),wDateType, wType],
                       @OnResultSummary, @OnError);
end;

procedure TfrmVehicleDetails.qDieselInfoAfterOpen(DataSet: TDataSet);
begin
  gdaDiesel.Active := True;

  TFloatField(qDieselInfo.FieldByName('litres')).DisplayFormat := '#,##0.00';
  TFloatField(qDieselInfo.FieldByName('price')).DisplayFormat := '#,##0.00';
  TFloatField(qDieselInfo.FieldByName('amount')).DisplayFormat := '#,##0.00';
  TIntegerField(qDieselInfo.FieldByName('startkilos')).DisplayFormat := '#,##0';
  TIntegerField(qDieselInfo.FieldByName('endkilos')).DisplayFormat := '#,##0';
  TIntegerField(qDieselInfo.FieldByName('totalkilos')).DisplayFormat := '#,##0';
end;

procedure TfrmVehicleDetails.qLoadsInfoAfterOpen(DataSet: TDataSet);
begin
  gdaLoads.Active := True;

  TFloatField(qLoadsInfo.FieldByName('tons')).DisplayFormat := '#,##0.00';
  TFloatField(qLoadsInfo.FieldByName('rate')).DisplayFormat := '#,##0.00';
  TFloatField(qLoadsInfo.FieldByName('revenue')).DisplayFormat := '#,##0.00';
end;

procedure TfrmVehicleDetails.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wsbMain := TScrollBox.Create(Self);
  wpBottom := TPanel.Create(Self);
  btnBack := TSpeedButton.Create(Self);
  gdaLoads := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebWaitMessage1 := TWaitMessage.Create(Self);
  gdaDiesel := TTMSFNCGridDatabaseAdapter.Create(Self);
  pcMain := TTMSFNCPageControl.Create(Self);
  tpDiesel := TTMSFNCPageControlContainer.Create(Self);
  gDiesel := TTMSFNCGrid.Create(Self);
  tpLoads := TTMSFNCPageControlContainer.Create(Self);
  gLoads := TTMSFNCGrid.Create(Self);
  MessageDlg := TMessageDlg.Create(Self);
  wbDetails := TXDataWebClient.Create(Self);
  qLoadsInfo := TXDataWebDataSet.Create(Self);
  qLoadsInfoLoadConNo := TIntegerField.Create(Self);
  qLoadsInfoRegNo := TStringField.Create(Self);
  qLoadsInfoEmpCode := TStringField.Create(Self);
  qLoadsInfoEmpName := TStringField.Create(Self);
  qLoadsInfoRoute := TStringField.Create(Self);
  qLoadsInfoLoadingDate := TDateField.Create(Self);
  qLoadsInfoOffLoadingDate := TDateField.Create(Self);
  qLoadsInfoTons := TFloatField.Create(Self);
  qLoadsInfoRate := TFloatField.Create(Self);
  qLoadsInfoLoadStartKilos := TIntegerField.Create(Self);
  qLoadsInfoStartKilos := TIntegerField.Create(Self);
  qLoadsInfoEndKilos := TIntegerField.Create(Self);
  qLoadsInfoClientInvNo := TStringField.Create(Self);
  qLoadsInfoSubsInvNo := TStringField.Create(Self);
  qLoadsInfoDocketNo := TStringField.Create(Self);
  qLoadsInfoInvoiceType := TStringField.Create(Self);
  qLoadsInfoRevenue := TFloatField.Create(Self);
  qLoadsInfoLoadingTime := TStringField.Create(Self);
  qLoadsInfoOffLoadingTime := TStringField.Create(Self);
  qLoadsInfoTravelTime := TStringField.Create(Self);
  qLoadsInfoTotalTravelTime := TStringField.Create(Self);
  dsLoadsInfo := TDataSource.Create(Self);
  qDieselInfo := TXDataWebDataSet.Create(Self);
  qDieselInfoOrderNo := TIntegerField.Create(Self);
  qDieselInfoRegNo := TStringField.Create(Self);
  qDieselInfoOrderDate := TDateField.Create(Self);
  qDieselInfoLitres := TFloatField.Create(Self);
  qDieselInfoPrice := TFloatField.Create(Self);
  qDieselInfoAmount := TFloatField.Create(Self);
  qDieselInfoStartKilos := TIntegerField.Create(Self);
  qDieselInfoEndKilos := TIntegerField.Create(Self);
  qDieselInfoTotalKilos := TIntegerField.Create(Self);
  qDieselInfoFullFill := TBooleanField.Create(Self);
  qDieselInfoFuelConsumption := TFloatField.Create(Self);
  qDieselInfoDepotName := TStringField.Create(Self);
  qDieselInfoEmpCode := TStringField.Create(Self);
  qDieselInfoEmpName := TStringField.Create(Self);
  dsDieselInfo := TDataSource.Create(Self);
  pmLoads := TPopupMenu.Create(Self);
  pmlUpdateKilos := TMenuItem.Create(Self);
  pmlUpdateDriver := TMenuItem.Create(Self);

  wsbMain.BeforeLoadDFMValues;
  wpBottom.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  gdaLoads.BeforeLoadDFMValues;
  WebWaitMessage1.BeforeLoadDFMValues;
  gdaDiesel.BeforeLoadDFMValues;
  pcMain.BeforeLoadDFMValues;
  tpDiesel.BeforeLoadDFMValues;
  gDiesel.BeforeLoadDFMValues;
  tpLoads.BeforeLoadDFMValues;
  gLoads.BeforeLoadDFMValues;
  MessageDlg.BeforeLoadDFMValues;
  wbDetails.BeforeLoadDFMValues;
  qLoadsInfo.BeforeLoadDFMValues;
  qLoadsInfoLoadConNo.BeforeLoadDFMValues;
  qLoadsInfoRegNo.BeforeLoadDFMValues;
  qLoadsInfoEmpCode.BeforeLoadDFMValues;
  qLoadsInfoEmpName.BeforeLoadDFMValues;
  qLoadsInfoRoute.BeforeLoadDFMValues;
  qLoadsInfoLoadingDate.BeforeLoadDFMValues;
  qLoadsInfoOffLoadingDate.BeforeLoadDFMValues;
  qLoadsInfoTons.BeforeLoadDFMValues;
  qLoadsInfoRate.BeforeLoadDFMValues;
  qLoadsInfoLoadStartKilos.BeforeLoadDFMValues;
  qLoadsInfoStartKilos.BeforeLoadDFMValues;
  qLoadsInfoEndKilos.BeforeLoadDFMValues;
  qLoadsInfoClientInvNo.BeforeLoadDFMValues;
  qLoadsInfoSubsInvNo.BeforeLoadDFMValues;
  qLoadsInfoDocketNo.BeforeLoadDFMValues;
  qLoadsInfoInvoiceType.BeforeLoadDFMValues;
  qLoadsInfoRevenue.BeforeLoadDFMValues;
  qLoadsInfoLoadingTime.BeforeLoadDFMValues;
  qLoadsInfoOffLoadingTime.BeforeLoadDFMValues;
  qLoadsInfoTravelTime.BeforeLoadDFMValues;
  qLoadsInfoTotalTravelTime.BeforeLoadDFMValues;
  dsLoadsInfo.BeforeLoadDFMValues;
  qDieselInfo.BeforeLoadDFMValues;
  qDieselInfoOrderNo.BeforeLoadDFMValues;
  qDieselInfoRegNo.BeforeLoadDFMValues;
  qDieselInfoOrderDate.BeforeLoadDFMValues;
  qDieselInfoLitres.BeforeLoadDFMValues;
  qDieselInfoPrice.BeforeLoadDFMValues;
  qDieselInfoAmount.BeforeLoadDFMValues;
  qDieselInfoStartKilos.BeforeLoadDFMValues;
  qDieselInfoEndKilos.BeforeLoadDFMValues;
  qDieselInfoTotalKilos.BeforeLoadDFMValues;
  qDieselInfoFullFill.BeforeLoadDFMValues;
  qDieselInfoFuelConsumption.BeforeLoadDFMValues;
  qDieselInfoDepotName.BeforeLoadDFMValues;
  qDieselInfoEmpCode.BeforeLoadDFMValues;
  qDieselInfoEmpName.BeforeLoadDFMValues;
  dsDieselInfo.BeforeLoadDFMValues;
  pmLoads.BeforeLoadDFMValues;
  pmlUpdateKilos.BeforeLoadDFMValues;
  pmlUpdateDriver.BeforeLoadDFMValues;
  try
    Name := 'frmVehicleDetails';
    Width := 1100;
    Height := 463;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    wsbMain.SetParentComponent(Self);
    wsbMain.Name := 'wsbMain';
    wsbMain.Left := 0;
    wsbMain.Top := 0;
    wsbMain.Width := 1100;
    wsbMain.Height := 463;
    wsbMain.Align := alClient;
    wsbMain.BorderStyle := bsSingle;
    wpBottom.SetParentComponent(wsbMain);
    wpBottom.Name := 'wpBottom';
    wpBottom.Left := 0;
    wpBottom.Top := 394;
    wpBottom.Width := 1100;
    wpBottom.Height := 69;
    wpBottom.Align := alBottom;
    wpBottom.Color := clSilver;
    wpBottom.ElementBodyClassName := 'card-body';
    wpBottom.TabOrder := 0;
    btnBack.SetParentComponent(wpBottom);
    btnBack.Name := 'btnBack';
    btnBack.Left := 952;
    btnBack.Top := 10;
    btnBack.Width := 139;
    btnBack.Height := 49;
    btnBack.Caption := 'Close';
    btnBack.Color := clCrimson;
    btnBack.Font.Charset := DEFAULT_CHARSET;
    btnBack.Font.Color := clWhite;
    btnBack.Font.Height := -15;
    btnBack.Font.Name := 'Tahoma';
    btnBack.Font.Style := [fsBold];
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.MaterialGlyph := 'close';
    btnBack.ParentFont := False;
    btnBack.TabOrder := 0;
    btnBack.WidthPercent := 100.000000000000000000;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    gdaLoads.SetParentComponent(wpBottom);
    gdaLoads.Name := 'gdaLoads';
    gdaLoads.Left := 456;
    gdaLoads.Top := 27;
    gdaLoads.Width := 26;
    gdaLoads.Height := 26;
    gdaLoads.Visible := True;
    gdaLoads.Grid := gLoads;
    gdaLoads.DataSource := dsLoadsInfo;
    gdaLoads.Columns.Clear;
    with gdaLoads.Columns.Add do
    begin
      Header := 'No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'LoadConNo';
      Header := 'Loadcon No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'LoadingDate';
      Header := 'Loading Date';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'EmpName';
      Header := 'Employee Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'Route';
      Header := 'Route';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'Rate';
      Header := 'Rate';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'Tons';
      Header := 'Tons';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'Revenue';
      Header := 'Revenue';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'TotalTravelTime';
      Header := 'TT Time';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'LoadingTime';
      Header := 'Loading Time';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'TravelTime';
      Header := 'Travel Time';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaLoads.Columns.Add do
    begin
      FieldName := 'OffLoadingTime';
      Header := 'OffLoading Time';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    gdaLoads.AutoCreateColumns := False;
    WebWaitMessage1.SetParentComponent(wpBottom);
    WebWaitMessage1.Name := 'WebWaitMessage1';
    WebWaitMessage1.Left := 520;
    WebWaitMessage1.Top := 21;
    WebWaitMessage1.Width := 24;
    WebWaitMessage1.Height := 24;
    WebWaitMessage1.Opacity := 0.200000000000000000;
    WebWaitMessage1.Picture.LoadFromFile('vehicle.details.wpBottom.WebWaitMessage1.Picture.gif');
    gdaDiesel.SetParentComponent(wpBottom);
    gdaDiesel.Name := 'gdaDiesel';
    gdaDiesel.Left := 592;
    gdaDiesel.Top := 24;
    gdaDiesel.Width := 26;
    gdaDiesel.Height := 26;
    gdaDiesel.Visible := True;
    gdaDiesel.Grid := gDiesel;
    gdaDiesel.DataSource := dsDieselInfo;
    gdaDiesel.Columns.Clear;
    with gdaDiesel.Columns.Add do
    begin
      Header := 'No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'OrderNo';
      Header := 'Order No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'DepotName';
      Header := 'Depot Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'OrderDate';
      Header := 'Order Date';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'Litres';
      Header := 'Litres';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'Price';
      Header := 'Price';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'Amount';
      Header := 'Amount';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'StartKilos';
      Header := 'Start Kilos';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'EndKilos';
      Header := 'End Kilos';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'TotalKilos';
      Header := 'Total Kilos';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'FuelConsumption';
      Header := 'Consumption';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'FullFill';
      Header := 'Full Fill';
      CheckBoxField := True;
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'EmpCode';
      Header := 'Employee Code';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDiesel.Columns.Add do
    begin
      FieldName := 'EmpName';
      Header := 'Employee Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    gdaDiesel.AutoCreateColumns := False;
    pcMain.SetParentComponent(wsbMain);
    pcMain.Name := 'pcMain';
    pcMain.Left := 0;
    pcMain.Top := 0;
    pcMain.Width := 1100;
    pcMain.Height := 394;
    pcMain.AdaptToStyle := True;
    pcMain.Align := alClient;
    pcMain.ParentDoubleBuffered := False;
    pcMain.Color := clBtnFace;
    pcMain.DoubleBuffered := True;
    pcMain.TabOrder := 1;
    pcMain.Fill.Kind := gfkNone;
    pcMain.Stroke.Kind := gskNone;
    pcMain.Stroke.Color := 15987699;
    pcMain.TabAppearance.Font.Charset := DEFAULT_CHARSET;
    pcMain.TabAppearance.Font.Color := clWindowText;
    pcMain.TabAppearance.Font.Height := -11;
    pcMain.TabAppearance.Font.Name := 'Segoe UI';
    pcMain.TabAppearance.Font.Style := [];
    pcMain.TabAppearance.Fill.Color := 15385233;
    pcMain.TabAppearance.Stroke.Color := 15987699;
    pcMain.TabAppearance.ActiveStroke.Color := 15987699;
    pcMain.TabAppearance.DownFill.Color := 15119995;
    pcMain.TabAppearance.DownStroke.Color := 15987699;
    pcMain.TabAppearance.HoverFill.Color := 15650471;
    pcMain.TabAppearance.HoverStroke.Color := 15987699;
    pcMain.TabAppearance.TextSpacing := 0.000000000000000000;
    pcMain.TabAppearance.ShowFocus := False;
    pcMain.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    pcMain.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    pcMain.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    pcMain.TabAppearance.BadgeFill.Color := 15385233;
    pcMain.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    pcMain.TabAppearance.BadgeFont.Color := clDarkred;
    pcMain.TabAppearance.BadgeFont.Height := -11;
    pcMain.TabAppearance.BadgeFont.Name := 'Segoe UI';
    pcMain.TabAppearance.BadgeFont.Style := [fsBold];
    pcMain.ButtonAppearance.Fill.Color := 15385233;
    pcMain.ButtonAppearance.Stroke.Color := 15987699;
    pcMain.ButtonAppearance.DownFill.Color := 15119995;
    pcMain.ButtonAppearance.DownStroke.Color := 15987699;
    pcMain.ButtonAppearance.HoverFill.Color := 15650471;
    pcMain.ButtonAppearance.HoverStroke.Color := 15987699;
    pcMain.ButtonAppearance.CloseIcon.LoadFromFile('vehicle.details.wsbMain.pcMain.ButtonAppearance.CloseIcon.svg');
    pcMain.ButtonAppearance.InsertIcon.LoadFromFile('vehicle.details.wsbMain.pcMain.ButtonAppearance.InsertIcon.svg');
    pcMain.ButtonAppearance.TabListIcon.LoadFromFile('vehicle.details.wsbMain.pcMain.ButtonAppearance.TabListIcon.svg');
    pcMain.ButtonAppearance.ScrollNextIcon.LoadFromFile('vehicle.details.wsbMain.pcMain.ButtonAppearance.ScrollNextIcon.svg');
    pcMain.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('vehicle.details.wsbMain.pcMain.ButtonAppearance.ScrollPreviousIcon.svg');
    pcMain.TabSize.Margins.Left := 8.000000000000000000;
    pcMain.TabSize.Margins.Top := 8.000000000000000000;
    pcMain.TabSize.Margins.Right := 8.000000000000000000;
    pcMain.TabSize.Margins.Bottom := 8.000000000000000000;
    pcMain.Pages.Clear;
    with pcMain.Pages.Add do
    begin
      Text := 'Loads Details';
      UseDefaultAppearance := True;
    end;
    with pcMain.Pages.Add do
    begin
      Text := 'Diesel Details';
      UseDefaultAppearance := True;
    end;
    tpDiesel.SetParentComponent(pcMain);
    tpDiesel.Name := 'tpDiesel';
    tpDiesel.AlignWithMargins := True;
    tpDiesel.Left := 0;
    tpDiesel.Top := 29;
    tpDiesel.Width := 1100;
    tpDiesel.Height := 365;
    tpDiesel.Margins.Left := 0;
    tpDiesel.Margins.Top := 29;
    tpDiesel.Margins.Right := 0;
    tpDiesel.Margins.Bottom := 0;
    tpDiesel.AdaptToStyle := True;
    tpDiesel.Align := alClient;
    tpDiesel.ParentDoubleBuffered := False;
    tpDiesel.Color := clSilver;
    tpDiesel.DoubleBuffered := True;
    tpDiesel.TabStop := False;
    tpDiesel.TabOrder := 1;
    tpDiesel.Visible := False;
    tpDiesel.Stroke.Color := 15987699;
    tpDiesel.PageIndex := 1;
    tpDiesel.IsActive := False;
    gDiesel.SetParentComponent(tpDiesel);
    gDiesel.Name := 'gDiesel';
    gDiesel.Left := 0;
    gDiesel.Top := 0;
    gDiesel.Width := 1100;
    gDiesel.Height := 365;
    gDiesel.Align := alClient;
    gDiesel.ParentDoubleBuffered := False;
    gDiesel.DoubleBuffered := True;
    gDiesel.TabOrder := 0;
    gDiesel.DefaultRowHeight := 40.000000000000000000;
    gDiesel.ColumnCount := 13;
    gDiesel.RowCount := 1;
    gDiesel.Options.Bands.Enabled := True;
    gDiesel.Options.Editing.CalcFormat := '%g';
    gDiesel.Options.Grouping.CalcFormat := '%g';
    gDiesel.Options.Grouping.GroupCountFormat := '(%d)';
    gDiesel.Options.IO.XMLEncoding := 'ISO-8859-1';
    gDiesel.Options.Mouse.ClickMargin := 0;
    gDiesel.Options.Mouse.ColumnSizeMargin := 6;
    gDiesel.Options.Mouse.RowSizeMargin := 6;
    gDiesel.Adapter := gdaDiesel;
    gDiesel.Columns.Clear;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 30.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 89.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 194.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 96.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 78.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 113.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 68.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 79.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 79.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 79.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 80.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 103.000000000000000000;
    end;
    with gDiesel.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 273.000000000000000000;
    end;
    gDiesel.DefaultFont.Charset := DEFAULT_CHARSET;
    gDiesel.DefaultFont.Color := clWindowText;
    gDiesel.DefaultFont.Height := -11;
    gDiesel.DefaultFont.Name := 'Segoe UI';
    gDiesel.DefaultFont.Style := [];
    gDiesel.TopRow := 1;
    gDiesel.Appearance.FixedLayout.Fill.Color := 16380654;
    gDiesel.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.FixedLayout.Font.Color := 4539717;
    gDiesel.Appearance.FixedLayout.Font.Height := -13;
    gDiesel.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.FixedLayout.Font.Style := [fsBold];
    gDiesel.Appearance.NormalLayout.Fill.Color := 16578806;
    gDiesel.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.NormalLayout.Font.Color := 8026746;
    gDiesel.Appearance.NormalLayout.Font.Height := -11;
    gDiesel.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.NormalLayout.Font.Style := [];
    gDiesel.Appearance.GroupLayout.Fill.Color := 12817262;
    gDiesel.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.GroupLayout.Font.Color := clBlack;
    gDiesel.Appearance.GroupLayout.Font.Height := -11;
    gDiesel.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.GroupLayout.Font.Style := [];
    gDiesel.Appearance.SummaryLayout.Fill.Color := 14009785;
    gDiesel.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.SummaryLayout.Font.Color := clBlack;
    gDiesel.Appearance.SummaryLayout.Font.Height := -11;
    gDiesel.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.SummaryLayout.Font.Style := [];
    gDiesel.Appearance.SelectedLayout.Fill.Color := 16441019;
    gDiesel.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.SelectedLayout.Font.Color := 4539717;
    gDiesel.Appearance.SelectedLayout.Font.Height := -11;
    gDiesel.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.SelectedLayout.Font.Style := [];
    gDiesel.Appearance.FocusedLayout.Fill.Color := 16039284;
    gDiesel.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.FocusedLayout.Font.Color := 4539717;
    gDiesel.Appearance.FocusedLayout.Font.Height := -11;
    gDiesel.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.FocusedLayout.Font.Style := [];
    gDiesel.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gDiesel.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gDiesel.Appearance.FixedSelectedLayout.Font.Height := -11;
    gDiesel.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.FixedSelectedLayout.Font.Style := [];
    gDiesel.Appearance.BandLayout.Fill.Color := 16711679;
    gDiesel.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gDiesel.Appearance.BandLayout.Font.Color := 8026746;
    gDiesel.Appearance.BandLayout.Font.Height := -11;
    gDiesel.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gDiesel.Appearance.BandLayout.Font.Style := [];
    gDiesel.Appearance.ProgressLayout.Format := '%.0f%%';
    gDiesel.LeftCol := 1;
    gDiesel.ScrollMode := scmItemScrolling;
    gDiesel.DesignTimeSampleData := True;
    SetEvent(gDiesel, Self, 'OnGetCellData', 'gDieselGetCellData');
    tpLoads.SetParentComponent(pcMain);
    tpLoads.Name := 'tpLoads';
    tpLoads.AlignWithMargins := True;
    tpLoads.Left := 0;
    tpLoads.Top := 29;
    tpLoads.Width := 1100;
    tpLoads.Height := 365;
    tpLoads.Margins.Left := 0;
    tpLoads.Margins.Top := 29;
    tpLoads.Margins.Right := 0;
    tpLoads.Margins.Bottom := 0;
    tpLoads.AdaptToStyle := True;
    tpLoads.Align := alClient;
    tpLoads.ParentDoubleBuffered := False;
    tpLoads.Color := clSilver;
    tpLoads.DoubleBuffered := True;
    tpLoads.TabStop := False;
    tpLoads.TabOrder := 0;
    tpLoads.Stroke.Color := 15987699;
    tpLoads.PageIndex := 0;
    tpLoads.IsActive := True;
    gLoads.SetParentComponent(tpLoads);
    gLoads.Name := 'gLoads';
    gLoads.Left := 0;
    gLoads.Top := 0;
    gLoads.Width := 1100;
    gLoads.Height := 365;
    gLoads.Align := alClient;
    gLoads.ParentDoubleBuffered := False;
    gLoads.DoubleBuffered := True;
    gLoads.PopupMenu := pmLoads;
    gLoads.TabOrder := 0;
    gLoads.DefaultRowHeight := 40.000000000000000000;
    gLoads.ColumnCount := 13;
    gLoads.RowCount := 1;
    gLoads.Options.Bands.Enabled := True;
    gLoads.Options.Editing.CalcFormat := '%g';
    gLoads.Options.Grouping.CalcFormat := '%g';
    gLoads.Options.Grouping.GroupCountFormat := '(%d)';
    gLoads.Options.IO.XMLEncoding := 'ISO-8859-1';
    gLoads.Options.Mouse.ClickMargin := 0;
    gLoads.Options.Mouse.ColumnSizeMargin := 6;
    gLoads.Options.Mouse.RowSizeMargin := 6;
    gLoads.Adapter := gdaLoads;
    gLoads.Columns.Clear;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 30.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 68.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 115.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 95.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 206.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 292.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 73.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 68.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      ReadOnly := True;
      Width := 81.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 106.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 106.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 106.000000000000000000;
    end;
    with gLoads.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 106.000000000000000000;
    end;
    gLoads.DefaultFont.Charset := DEFAULT_CHARSET;
    gLoads.DefaultFont.Color := clWindowText;
    gLoads.DefaultFont.Height := -11;
    gLoads.DefaultFont.Name := 'Segoe UI';
    gLoads.DefaultFont.Style := [];
    gLoads.TopRow := 1;
    gLoads.Appearance.FixedLayout.Fill.Color := 16380654;
    gLoads.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.FixedLayout.Font.Color := 4539717;
    gLoads.Appearance.FixedLayout.Font.Height := -13;
    gLoads.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.FixedLayout.Font.Style := [fsBold];
    gLoads.Appearance.NormalLayout.Fill.Color := 16578806;
    gLoads.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.NormalLayout.Font.Color := 8026746;
    gLoads.Appearance.NormalLayout.Font.Height := -11;
    gLoads.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.NormalLayout.Font.Style := [];
    gLoads.Appearance.GroupLayout.Fill.Color := 12817262;
    gLoads.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.GroupLayout.Font.Color := clBlack;
    gLoads.Appearance.GroupLayout.Font.Height := -11;
    gLoads.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.GroupLayout.Font.Style := [];
    gLoads.Appearance.SummaryLayout.Fill.Color := 14009785;
    gLoads.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.SummaryLayout.Font.Color := clBlack;
    gLoads.Appearance.SummaryLayout.Font.Height := -11;
    gLoads.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.SummaryLayout.Font.Style := [];
    gLoads.Appearance.SelectedLayout.Fill.Color := 16441019;
    gLoads.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.SelectedLayout.Font.Color := 4539717;
    gLoads.Appearance.SelectedLayout.Font.Height := -11;
    gLoads.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.SelectedLayout.Font.Style := [];
    gLoads.Appearance.FocusedLayout.Fill.Color := 16039284;
    gLoads.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.FocusedLayout.Font.Color := 4539717;
    gLoads.Appearance.FocusedLayout.Font.Height := -11;
    gLoads.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.FocusedLayout.Font.Style := [];
    gLoads.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gLoads.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gLoads.Appearance.FixedSelectedLayout.Font.Height := -11;
    gLoads.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.FixedSelectedLayout.Font.Style := [];
    gLoads.Appearance.BandLayout.Fill.Color := 16711679;
    gLoads.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gLoads.Appearance.BandLayout.Font.Color := 8026746;
    gLoads.Appearance.BandLayout.Font.Height := -11;
    gLoads.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gLoads.Appearance.BandLayout.Font.Style := [];
    gLoads.Appearance.ProgressLayout.Format := '%.0f%%';
    gLoads.LeftCol := 1;
    gLoads.ScrollMode := scmItemScrolling;
    gLoads.DesignTimeSampleData := True;
    SetEvent(gLoads, Self, 'OnGetCellData', 'gLoadsGetCellData');
    MessageDlg.SetParentComponent(gLoads);
    MessageDlg.Name := 'MessageDlg';
    MessageDlg.Left := 408;
    MessageDlg.Top := 288;
    MessageDlg.Width := 24;
    MessageDlg.Height := 24;
    MessageDlg.Buttons := [mbOK];
    MessageDlg.Opacity := 0.200000000000000000;
    MessageDlg.ElementButtonClassName := 'btn';
    MessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MessageDlg.ElementTitleClassName := 'text-body';
    MessageDlg.ElementContentClassName := 'text-body';
    wbDetails.SetParentComponent(Self);
    wbDetails.Name := 'wbDetails';
    wbDetails.Connection := dmData.dbConnect;
    wbDetails.Left := 456;
    wbDetails.Top := 124;
    qLoadsInfo.SetParentComponent(Self);
    qLoadsInfo.Name := 'qLoadsInfo';
    qLoadsInfo.AfterOpen := qLoadsInfoAfterOpen;
    qLoadsInfo.Connection := dmData.dbConnect;
    qLoadsInfo.Left := 472;
    qLoadsInfo.Top := 196;
    qLoadsInfoLoadConNo.SetParentComponent(qLoadsInfo);
    qLoadsInfoLoadConNo.Name := 'qLoadsInfoLoadConNo';
    qLoadsInfoLoadConNo.FieldName := 'LoadConNo';
    qLoadsInfoRegNo.SetParentComponent(qLoadsInfo);
    qLoadsInfoRegNo.Name := 'qLoadsInfoRegNo';
    qLoadsInfoRegNo.FieldName := 'RegNo';
    qLoadsInfoEmpCode.SetParentComponent(qLoadsInfo);
    qLoadsInfoEmpCode.Name := 'qLoadsInfoEmpCode';
    qLoadsInfoEmpCode.FieldName := 'EmpCode';
    qLoadsInfoEmpName.SetParentComponent(qLoadsInfo);
    qLoadsInfoEmpName.Name := 'qLoadsInfoEmpName';
    qLoadsInfoEmpName.FieldName := 'EmpName';
    qLoadsInfoRoute.SetParentComponent(qLoadsInfo);
    qLoadsInfoRoute.Name := 'qLoadsInfoRoute';
    qLoadsInfoRoute.FieldName := 'Route';
    qLoadsInfoLoadingDate.SetParentComponent(qLoadsInfo);
    qLoadsInfoLoadingDate.Name := 'qLoadsInfoLoadingDate';
    qLoadsInfoLoadingDate.FieldName := 'LoadingDate';
    qLoadsInfoLoadingDate.DisplayFormat := 'dd/MM/yyyy';
    qLoadsInfoOffLoadingDate.SetParentComponent(qLoadsInfo);
    qLoadsInfoOffLoadingDate.Name := 'qLoadsInfoOffLoadingDate';
    qLoadsInfoOffLoadingDate.FieldName := 'OffLoadingDate';
    qLoadsInfoTons.SetParentComponent(qLoadsInfo);
    qLoadsInfoTons.Name := 'qLoadsInfoTons';
    qLoadsInfoTons.FieldName := 'Tons';
    qLoadsInfoRate.SetParentComponent(qLoadsInfo);
    qLoadsInfoRate.Name := 'qLoadsInfoRate';
    qLoadsInfoRate.FieldName := 'Rate';
    qLoadsInfoLoadStartKilos.SetParentComponent(qLoadsInfo);
    qLoadsInfoLoadStartKilos.Name := 'qLoadsInfoLoadStartKilos';
    qLoadsInfoLoadStartKilos.FieldName := 'LoadStartKilos';
    qLoadsInfoStartKilos.SetParentComponent(qLoadsInfo);
    qLoadsInfoStartKilos.Name := 'qLoadsInfoStartKilos';
    qLoadsInfoStartKilos.FieldName := 'StartKilos';
    qLoadsInfoEndKilos.SetParentComponent(qLoadsInfo);
    qLoadsInfoEndKilos.Name := 'qLoadsInfoEndKilos';
    qLoadsInfoEndKilos.FieldName := 'EndKilos';
    qLoadsInfoClientInvNo.SetParentComponent(qLoadsInfo);
    qLoadsInfoClientInvNo.Name := 'qLoadsInfoClientInvNo';
    qLoadsInfoClientInvNo.FieldName := 'ClientInvNo';
    qLoadsInfoSubsInvNo.SetParentComponent(qLoadsInfo);
    qLoadsInfoSubsInvNo.Name := 'qLoadsInfoSubsInvNo';
    qLoadsInfoSubsInvNo.FieldName := 'SubsInvNo';
    qLoadsInfoDocketNo.SetParentComponent(qLoadsInfo);
    qLoadsInfoDocketNo.Name := 'qLoadsInfoDocketNo';
    qLoadsInfoDocketNo.FieldName := 'DocketNo';
    qLoadsInfoInvoiceType.SetParentComponent(qLoadsInfo);
    qLoadsInfoInvoiceType.Name := 'qLoadsInfoInvoiceType';
    qLoadsInfoInvoiceType.FieldName := 'InvoiceType';
    qLoadsInfoRevenue.SetParentComponent(qLoadsInfo);
    qLoadsInfoRevenue.Name := 'qLoadsInfoRevenue';
    qLoadsInfoRevenue.FieldName := 'Revenue';
    qLoadsInfoLoadingTime.SetParentComponent(qLoadsInfo);
    qLoadsInfoLoadingTime.Name := 'qLoadsInfoLoadingTime';
    qLoadsInfoLoadingTime.FieldName := 'LoadingTime';
    qLoadsInfoOffLoadingTime.SetParentComponent(qLoadsInfo);
    qLoadsInfoOffLoadingTime.Name := 'qLoadsInfoOffLoadingTime';
    qLoadsInfoOffLoadingTime.FieldName := 'OffLoadingTime';
    qLoadsInfoTravelTime.SetParentComponent(qLoadsInfo);
    qLoadsInfoTravelTime.Name := 'qLoadsInfoTravelTime';
    qLoadsInfoTravelTime.FieldName := 'TravelTime';
    qLoadsInfoTotalTravelTime.SetParentComponent(qLoadsInfo);
    qLoadsInfoTotalTravelTime.Name := 'qLoadsInfoTotalTravelTime';
    qLoadsInfoTotalTravelTime.FieldName := 'TotalTravelTime';
    dsLoadsInfo.SetParentComponent(Self);
    dsLoadsInfo.Name := 'dsLoadsInfo';
    dsLoadsInfo.AutoEdit := False;
    dsLoadsInfo.DataSet := qLoadsInfo;
    dsLoadsInfo.Left := 520;
    dsLoadsInfo.Top := 204;
    qDieselInfo.SetParentComponent(Self);
    qDieselInfo.Name := 'qDieselInfo';
    qDieselInfo.AfterOpen := qDieselInfoAfterOpen;
    qDieselInfo.Connection := dmData.dbConnect;
    qDieselInfo.Left := 600;
    qDieselInfo.Top := 196;
    qDieselInfoOrderNo.SetParentComponent(qDieselInfo);
    qDieselInfoOrderNo.Name := 'qDieselInfoOrderNo';
    qDieselInfoOrderNo.FieldName := 'OrderNo';
    qDieselInfoRegNo.SetParentComponent(qDieselInfo);
    qDieselInfoRegNo.Name := 'qDieselInfoRegNo';
    qDieselInfoRegNo.FieldName := 'RegNo';
    qDieselInfoOrderDate.SetParentComponent(qDieselInfo);
    qDieselInfoOrderDate.Name := 'qDieselInfoOrderDate';
    qDieselInfoOrderDate.FieldName := 'OrderDate';
    qDieselInfoOrderDate.DisplayFormat := 'dd/MM/yyyy';
    qDieselInfoLitres.SetParentComponent(qDieselInfo);
    qDieselInfoLitres.Name := 'qDieselInfoLitres';
    qDieselInfoLitres.FieldName := 'Litres';
    qDieselInfoLitres.DisplayFormat := '#,#0.00';
    qDieselInfoPrice.SetParentComponent(qDieselInfo);
    qDieselInfoPrice.Name := 'qDieselInfoPrice';
    qDieselInfoPrice.FieldName := 'Price';
    qDieselInfoPrice.DisplayFormat := '#,#0.00';
    qDieselInfoAmount.SetParentComponent(qDieselInfo);
    qDieselInfoAmount.Name := 'qDieselInfoAmount';
    qDieselInfoAmount.FieldName := 'Amount';
    qDieselInfoAmount.DisplayFormat := '#,#0.00';
    qDieselInfoStartKilos.SetParentComponent(qDieselInfo);
    qDieselInfoStartKilos.Name := 'qDieselInfoStartKilos';
    qDieselInfoStartKilos.FieldName := 'StartKilos';
    qDieselInfoEndKilos.SetParentComponent(qDieselInfo);
    qDieselInfoEndKilos.Name := 'qDieselInfoEndKilos';
    qDieselInfoEndKilos.FieldName := 'EndKilos';
    qDieselInfoTotalKilos.SetParentComponent(qDieselInfo);
    qDieselInfoTotalKilos.Name := 'qDieselInfoTotalKilos';
    qDieselInfoTotalKilos.FieldName := 'TotalKilos';
    qDieselInfoFullFill.SetParentComponent(qDieselInfo);
    qDieselInfoFullFill.Name := 'qDieselInfoFullFill';
    qDieselInfoFullFill.FieldName := 'FullFill';
    qDieselInfoFuelConsumption.SetParentComponent(qDieselInfo);
    qDieselInfoFuelConsumption.Name := 'qDieselInfoFuelConsumption';
    qDieselInfoFuelConsumption.FieldName := 'FuelConsumption';
    qDieselInfoFuelConsumption.DisplayFormat := '#,#0.00';
    qDieselInfoDepotName.SetParentComponent(qDieselInfo);
    qDieselInfoDepotName.Name := 'qDieselInfoDepotName';
    qDieselInfoDepotName.FieldName := 'DepotName';
    qDieselInfoEmpCode.SetParentComponent(qDieselInfo);
    qDieselInfoEmpCode.Name := 'qDieselInfoEmpCode';
    qDieselInfoEmpCode.FieldName := 'EmpCode';
    qDieselInfoEmpName.SetParentComponent(qDieselInfo);
    qDieselInfoEmpName.Name := 'qDieselInfoEmpName';
    qDieselInfoEmpName.FieldName := 'EmpName';
    dsDieselInfo.SetParentComponent(Self);
    dsDieselInfo.Name := 'dsDieselInfo';
    dsDieselInfo.AutoEdit := False;
    dsDieselInfo.DataSet := qDieselInfo;
    dsDieselInfo.Left := 672;
    dsDieselInfo.Top := 204;
    pmLoads.SetParentComponent(Self);
    pmLoads.Name := 'pmLoads';
    pmLoads.Appearance.HamburgerMenu.Caption := 'Menu';
    pmLoads.Appearance.SubmenuIndicator := '&#9658;';
    pmLoads.Font.Charset := DEFAULT_CHARSET;
    pmLoads.Font.Color := clWindowText;
    pmLoads.Font.Height := -12;
    pmLoads.Font.Name := 'Segoe UI';
    pmLoads.Font.Style := [];
    pmLoads.Left := 488;
    pmLoads.Top := 293;
    pmlUpdateKilos.SetParentComponent(pmLoads);
    pmlUpdateKilos.Name := 'pmlUpdateKilos';
    pmlUpdateKilos.Caption := 'Update Kilos';
    pmlUpdateDriver.SetParentComponent(pmLoads);
    pmlUpdateDriver.Name := 'pmlUpdateDriver';
    pmlUpdateDriver.Caption := 'Update Driver';
  finally
    wsbMain.AfterLoadDFMValues;
    wpBottom.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    gdaLoads.AfterLoadDFMValues;
    WebWaitMessage1.AfterLoadDFMValues;
    gdaDiesel.AfterLoadDFMValues;
    pcMain.AfterLoadDFMValues;
    tpDiesel.AfterLoadDFMValues;
    gDiesel.AfterLoadDFMValues;
    tpLoads.AfterLoadDFMValues;
    gLoads.AfterLoadDFMValues;
    MessageDlg.AfterLoadDFMValues;
    wbDetails.AfterLoadDFMValues;
    qLoadsInfo.AfterLoadDFMValues;
    qLoadsInfoLoadConNo.AfterLoadDFMValues;
    qLoadsInfoRegNo.AfterLoadDFMValues;
    qLoadsInfoEmpCode.AfterLoadDFMValues;
    qLoadsInfoEmpName.AfterLoadDFMValues;
    qLoadsInfoRoute.AfterLoadDFMValues;
    qLoadsInfoLoadingDate.AfterLoadDFMValues;
    qLoadsInfoOffLoadingDate.AfterLoadDFMValues;
    qLoadsInfoTons.AfterLoadDFMValues;
    qLoadsInfoRate.AfterLoadDFMValues;
    qLoadsInfoLoadStartKilos.AfterLoadDFMValues;
    qLoadsInfoStartKilos.AfterLoadDFMValues;
    qLoadsInfoEndKilos.AfterLoadDFMValues;
    qLoadsInfoClientInvNo.AfterLoadDFMValues;
    qLoadsInfoSubsInvNo.AfterLoadDFMValues;
    qLoadsInfoDocketNo.AfterLoadDFMValues;
    qLoadsInfoInvoiceType.AfterLoadDFMValues;
    qLoadsInfoRevenue.AfterLoadDFMValues;
    qLoadsInfoLoadingTime.AfterLoadDFMValues;
    qLoadsInfoOffLoadingTime.AfterLoadDFMValues;
    qLoadsInfoTravelTime.AfterLoadDFMValues;
    qLoadsInfoTotalTravelTime.AfterLoadDFMValues;
    dsLoadsInfo.AfterLoadDFMValues;
    qDieselInfo.AfterLoadDFMValues;
    qDieselInfoOrderNo.AfterLoadDFMValues;
    qDieselInfoRegNo.AfterLoadDFMValues;
    qDieselInfoOrderDate.AfterLoadDFMValues;
    qDieselInfoLitres.AfterLoadDFMValues;
    qDieselInfoPrice.AfterLoadDFMValues;
    qDieselInfoAmount.AfterLoadDFMValues;
    qDieselInfoStartKilos.AfterLoadDFMValues;
    qDieselInfoEndKilos.AfterLoadDFMValues;
    qDieselInfoTotalKilos.AfterLoadDFMValues;
    qDieselInfoFullFill.AfterLoadDFMValues;
    qDieselInfoFuelConsumption.AfterLoadDFMValues;
    qDieselInfoDepotName.AfterLoadDFMValues;
    qDieselInfoEmpCode.AfterLoadDFMValues;
    qDieselInfoEmpName.AfterLoadDFMValues;
    dsDieselInfo.AfterLoadDFMValues;
    pmLoads.AfterLoadDFMValues;
    pmlUpdateKilos.AfterLoadDFMValues;
    pmlUpdateDriver.AfterLoadDFMValues;
  end;
end;

end.
